import { setupLocale } from "../localizationManager";

export var arabicStrings = {
  // "Group By Me"
  groupButton: "زرار المجموعة",
  // "Ungroup By Me"
  ungroupButton: "تم التحديث من خلالى",
  // "Select Me"
  selectButton: "اختر",
  // [Auto-translated] "Column reorder"
  columnReorder: "إعادة ترتيب الأعمدة",
  // "Hide column"
  hideColumn: "اخفاء العمود",
  // "Show column"
  showColumn: "اظهار",
  // [Auto-translated] "Columns"
  columns: "الأعمدة",
  // "Make column private"
  makePrivateColumn: "أجعل العمود خاص",
  // "Make column public"
  makePublicColumn: "أجعل العمود عام",
  // "Move to Detail"
  moveToDetail: "انتقل إلى التفاصيل",
  // "Show as Column"
  showAsColumn: "إظهار كعمود",
  // "Search..."
  filterPlaceholder: "بحث...",
  // "Remove rows"
  removeRows: "حذف",
  // "Show"
  showLabel: "اظهار",
  // "entries"
  entriesLabel: "مدخلات",
  // [Auto-translated] "Entries on Page:"
  entriesOnPageLabel: "المشاركات على الصفحة:",
  // "Texts in table"
  visualizer_text: "جداول",
  // "Wordcloud"
  visualizer_wordcloud: "كلمات",
  // "Histogram"
  visualizer_histogram: "الرسم البياني",
  // "Average"
  visualizer_number: "متوسط",
  // [Auto-translated] "Average"
  visualizer_average: "المتوسط",
  // "Table"
  visualizer_choices: "جدول",
  // "Chart"
  visualizer_selectBase: "رسم بياني",
  // [Auto-translated] "Chart"
  visualizer_matrix: "جدول",
  // [Auto-translated] "Bar"
  chartType_bar: "بار",
  // "Vertical Bar"
  chartType_vbar: "شريط عمودي",
  // "Stacked Bar"
  chartType_stackedbar: "شريط مكدس",
  // "Doughnut"
  chartType_doughnut: "مخطط حلقي",
  // "Pie"
  chartType_pie: "مخطط دائري",
  // "Scatter"
  chartType_scatter: "مخطط التشتت",
  // "Gauge"
  chartType_gauge: "مخطط القياس",
  // "Bullet"
  chartType_bullet: "مخطط نقطي",
  // [Auto-translated] "Line"
  chartType_line: "سطر",
  // [Auto-translated] "Radar"
  chartType_radar: "رادار",
  // [Auto-translated] "Histogram"
  chartType_histogram: "مخطط التكرار الوظيفي",
  // [Auto-translated] "Vertical Histogram"
  chartType_vhistogram: "المخطط التكراري العمودي",
  // [Auto-translated] "Stacked Histogram"
  chartType_stackedhistogram: "مخطط التكرار المكدس",
  // "Hide"
  hideButton: "اخفاء",
  // "Make private"
  makePrivateButton: "أجعل خاص",
  // "Make public"
  makePublicButton: "أجعل عام",
  // "Show"
  showButton: "اظهار",
  // "Filter"
  filter: "ترشح",
  // "Reset Filter"
  resetFilter: "إعادة تعيين",
  // "Change Locale"
  changeLocale: "تغيير اللغة",
  // "Clear"
  clearButton: "مسح",
  // "Choose question to show..."
  addElement: "اختر سؤالاً للعرض ...",
  // [Auto-translated] "All questions"
  allQuestions: "جميع الأسئلة",
  // [Auto-translated] "Select all"
  selectAll: "اختر الجميع",
  // [Auto-translated] "Clear selection"
  clearSelection: "اختيار واضح",
  // "Default Order"
  defaultOrder: "الترتيب الافتراضي",
  // "Ascending"
  ascOrder: "تصاعدى",
  // "Descending"
  descOrder: "تنازلى",
  // "Show minor columns"
  showMinorColumns: "إظهار الأعمدة الثانوية",
  // [Auto-translated] "Actions"
  actionsColumn: "الاجراءات",
  // "Other items and comments"
  otherCommentTitle: "بنود وتعليقات أخرى",
  // "Show percentages"
  showPercentages: "عرض النسب المئوية",
  // "Hide percentages"
  hidePercentages: "إخفاء النسب",
  // [Auto-translated] "Export As..."
  exportAs: "تصدير ك...",
  // [Auto-translated] "PDF"
  pdfDownloadCaption: "PDF",
  // [Auto-translated] "Excel"
  xlsxDownloadCaption: "إكسل",
  // [Auto-translated] "CSV"
  csvDownloadCaption: "CSV",
  // [Auto-translated] "Export as PDF"
  pdfDownloadHint: "تصدير كملف PDF",
  // [Auto-translated] "Export as Excel"
  xlsxDownloadHint: "تصدير كإكسل",
  // [Auto-translated] "Export as CSV"
  csvDownloadHint: "التصدير ك CSV",
  // "Download plot as a PNG file"
  saveDiagramAsPNG: "تنزيل بصيغة png",
  // [Auto-translated] "response(s)"
  responsesText: "الردود (الردود)",
  // [Auto-translated] "No data"
  noData: "لا توجد بيانات",
  // [Auto-translated] "Select date range..."
  selectDateRange: "اختر نطاق التاريخ...",
  // [Auto-translated] "Start date"
  startDate: "تاريخ البدء",
  // [Auto-translated] "End date"
  endDate: "تاريخ النهاية",
  // [Auto-translated] "Include today"
  includeToday: "أدرج اليوم",
  // [Auto-translated] "Custom"
  reportingPeriodCustom: "العرف",
  // [Auto-translated] "Last 7 days"
  reportingPeriodLast7days: "آخر 7 أيام",
  // [Auto-translated] "Last 14 days"
  reportingPeriodLast14days: "آخر 14 يوما",
  // [Auto-translated] "Last 28 days"
  reportingPeriodLast28days: "آخر 28 يوما",
  // [Auto-translated] "Last 30 days"
  reportingPeriodLast30days: "آخر 30 يوما",
  // [Auto-translated] "Last week (starts Monday)"
  reportingPeriodLastWeekMon: "الأسبوع الماضي (يبدأ يوم الاثنين)",
  // [Auto-translated] "Last week (starts Sunday)"
  reportingPeriodLastWeekSun: "الأسبوع الماضي (يبدأ يوم الأحد)",
  // [Auto-translated] "Last month"
  reportingPeriodLastMonth: "الشهر الماضي",
  // [Auto-translated] "Last quarter"
  reportingPeriodLastQuarter: "الربع الأخير",
  // [Auto-translated] "Last year"
  reportingPeriodLastYear: "العام الماضي",
  // [Auto-translated] "This week to date (starts Sunday)"
  reportingPeriodWtdSun: "هذا الأسبوع حتى الآن (يبدأ يوم الأحد)",
  // [Auto-translated] "This week to date (starts Monday)"
  reportingPeriodWtdMon: "هذا الأسبوع حتى الآن (يبدأ يوم الاثنين)",
  // [Auto-translated] "This month to date"
  reportingPeriodMtd: "هذا الشهر حتى الآن",
  // [Auto-translated] "This quarter to date"
  reportingPeriodQtd: "هذا الربع حتى الآن",
  // [Auto-translated] "This year to date"
  reportingPeriodYtd: "من هذا العام حتى الآن",
  // "Hide empty answers"
  hideEmptyAnswers: "إخفاء الإجابات الفارغة",
  // "Show empty answers"
  showEmptyAnswers: "إظهار الإجابات الفارغة",
  // "All answers"
  "topNValueText-1": "جميع الإجابات",
  // "Top 5 answers"
  topNValueText5: "أهم 5 إجابات",
  // "Top 10 answers"
  topNValueText10: "أفضل 10 إجابات",
  // "Top 20 answers"
  topNValueText20: "أفضل 20 إجابة",
  // "Hide missing answers"
  hideMissingAnswers: "إخفاء الإجابات المفقودة",
  // "Show missing answers"
  showMissingAnswers: "عرض الإجابات المفقودة",
  // "Missing answers"
  missingAnswersLabel: "أجوبة مفقودة",
  // "This question type is not visualized yet"
  noVisualizerForQuestion: "لم يتم العرض بعد",
  // "There are no results yet"
  noResults: "لا يوجد نتائج للعرض",
  // "Per Values"
  showPerValues: "لكل القيم",
  // "Per Columns"
  showPerColumns: "لكل الأعمدة",
  // "Answer"
  answer: "إجب",
  // "Correct answer: "
  correctAnswer: "الاجابة الصحيحة: ",
  // [Auto-translated] "Percentage"
  percentage: "النسبه المئويه",
  // [Auto-translated] "Chart"
  statistics_chart: "جدول",
  // "Responses"
  responses: "الاستجابات",
  // [Auto-translated] "Total responses"
  totalResponses: "إجمالي الردود",
  // [Auto-translated] "NPS"
  visualizer_nps: "NPS",
  // [Auto-translated] "Chart"
  visualizer_boolean: "جدول",
  // [Auto-translated] "Table"
  visualizer_options: "جدول",
  // [Auto-translated] "NPS"
  npsScore: "NPS",
  // [Auto-translated] "Promoters"
  npsPromoters: "المروجين",
  // [Auto-translated] "Passives"
  npsPassives: "سلبيات",
  // [Auto-translated] "Detractors"
  npsDetractors: "المنتقدين",
  // [Auto-translated] "Category (X Axis)"
  axisXSelectorTitle: "الفئة (المحور العاشر)",
  // [Auto-translated] "Legend (Series)"
  axisYSelectorTitle: "الأسطورة (السلسلة)",
  // [Auto-translated] "Segments:"
  axisXAlternativeSelectorTitle: "قطاعات:",
  // [Auto-translated] "Groups:"
  axisYAlternativeSelectorTitle: "المجموعات:",
  // [Auto-translated] "Not selected"
  notSelected: "لم يتم اختياره",
  // [Auto-translated] "Secondary Y axis"
  secondYAxisToggleTitle: "المحور الثاني Y",
  // [Auto-translated] "Select a data field..."
  selectDataField: "اختر حقل بيانات...",
  // [Auto-translated] "Default"
  intervalMode_default: "افتراضي",
  // [Auto-translated] "Decades"
  intervalMode_decades: "عقود",
  // [Auto-translated] "Years"
  intervalMode_years: "اعوام",
  // [Auto-translated] "Quarters"
  intervalMode_quarters: "ارباع",
  // [Auto-translated] "Months"
  intervalMode_months: "أشهر",
  // [Auto-translated] "Days"
  intervalMode_days: "أيام",
  // [Auto-translated] "Auto"
  intervalMode_auto: "تلقائي",
  // [Auto-translated] "Intervals:"
  intervalModeTitle: "فترات:",
  // [Auto-translated] "Show individual values"
  noRunningTotals: "إظهار القيم الفردية",
  // [Auto-translated] "Show running totals"
  runningTotals: "إظهار الإجماليات الجارية",
  // [Auto-translated] "Compare periods"
  groupDateSeries: "مقارنة الفترات",
  // [Auto-translated] "View timeline"
  ungroupDateSeries: "عرض الجدول الزمني",
  // [Auto-translated] "None"
  noneAggregateText: "اي",
  // [Auto-translated] "Aggregate:"
  selectAggregateText: "تجميع:",
  // [Auto-translated] "Year ends with"
  groupedYearsAxisTitle: "ينتهي العام ب",
  // [Auto-translated] "Series {0}"
  seriesListSeries: "السلسلة {0}",
  // [Auto-translated] "Values"
  seriesListValuesLabel: "القيم",
  // [Auto-translated] "Remove"
  seriesListRemove: "إزالة",
  // [Auto-translated] "Add Series"
  seriesListAdd: "سلسلة إضافة",
  // [Auto-translated] "Move to second axis"
  seriesListMoveToSecondAxis: "الانتقال إلى المحور الثاني",
  // [Auto-translated] "Move to first axis"
  seriesListMoveToFirstAxis: "الانتقال إلى المحور الأول",
  // [Auto-translated] "Count"
  aggregationCount: "الكونت",
  // [Auto-translated] "Sum"
  aggregationSum: "المجموع",
  // [Auto-translated] "Average"
  aggregationAverage: "المتوسط",
  // [Auto-translated] "Close"
  close: "إغلاق",
  // [Auto-translated] "K"
  thousandsSuffix: "ألف",
  // [Auto-translated] "M"
  millionsSuffix: "مليون",
  // [Auto-translated] "B"
  billionsSuffix: "مليار"
};

setupLocale({ localeCode: "ar", strings: arabicStrings, nativeName: "العربية" });